import styled from "styled-components";

export const TileContainer = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 40px;
  margin-bottom: 24px;
`;
